export const CUSTOMER_ENDPOINTS = {
  customers: '/customer/customers',
} as const;
